const LiveAccessStatistics = () => import('@/views/main/live/liveAccessStatistics/LiveAccessStatistics.vue')
export default {
  path: '/main/live/liveAccessStatistics',
  name: 'LiveAccessStatistics',
  component: LiveAccessStatistics,
  children: []
}
